export default __webpack_public_path__ + "static/media/front_cover.0fbd3e5d.pdf";